var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCode = function SvgCode(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.802 5.914a.6.6 0 0 1 .849.848l-5.237 5.236 5.237 5.236a.6.6 0 0 1-.849.849l-5.66-5.66a.6.6 0 0 1 0-.849zm7.548 0a.6.6 0 0 1 .848 0l5.66 5.66a.6.6 0 0 1 0 .849l-5.66 5.66a.6.6 0 1 1-.848-.849l5.235-5.236-5.235-5.236a.6.6 0 0 1 0-.848"
  })));
};
export default SvgCode;